<app-toast></app-toast>
<app-replace-file-dialog></app-replace-file-dialog>
<app-delete-file-dialog></app-delete-file-dialog>
<app-invoice-upload-dialog [toast]="toast"></app-invoice-upload-dialog>

<!-- File Extraction Replacement -->
<input type="file" #fileInput accept="application/json,.json" (change)="onFileSelected($event)" hidden>

<div class="flex flex-row h-screen items-center">
    <app-desktop-sidebar [selectedItemId]="selectedSidebarItemId" class="mobile:hidden"></app-desktop-sidebar>
    <div class="h-screen p-6 overflow-y-auto w-full flex flex-col mobile:p-2">
        <div class="flex flex-col flex-[1]">
            <app-desktop-topbar pageName="{{ 'shared.pages.archive' | transloco }}"
                class="mobile:hidden"></app-desktop-topbar>
            <app-mobile-topbar class="hidden mobile:block" [selectedItemId]="selectedSidebarItemId"></app-mobile-topbar>

            <div
                class="mt-4 w-full max-w-ultrawide rounded-[20px] border-[1px] border-border flex flex-col p-5 gap-2 mobile:p-2">
                <div class="w-full flex desktop:justify-between items-center mobile:flex-col gap-2 mobile:gap-5">
                    <h2 class="text-2xl font-bold">{{ 'archive.overview.folders' | transloco }}</h2>
                    <div class="w-[150px] h-[50px]">
                        <app-custom-button buttonText="{{ 'invoice.upload_file' | transloco }}"
                            (click)="openInvoiceUploadDialog()" leadingIcon="assets/icons/add.svg"
                            backgroundColor="bg-primary" textColor="text-white" borderColor="border-primary"
                            hoverBorderColor="hover:border-primary-1200"
                            hoverBackgroundColor="hover:bg-primary-1200"></app-custom-button>
                    </div>
                </div>

                <!-- List of available folders -->
                <div
                    class="min-h-[100px] w-full flex flex-wrap gap-4 justify-start items-center mobile:flex-col mobile:min-h-[500px] mobile:border-2 mobile:rounded-2xl mobile:p-2">
                    <ng-container *ngFor="let folder of listOfFolders; let i = index">
                        <app-folder-button [folderInfo]="folder" [isSelected]="i === selectedFolder"
                            (click)="selectFolderClick(i)"></app-folder-button>
                    </ng-container>
                </div>

                <!-- Files -->
                <div class="mt-4 rounded-[16px] w-full flex-[1] border-[1px] border-neutral-200">
                    <div class="flex flex-col gap-2 mobile:items-center">
                        <div class="flex flex-wrap justify-between items-center mx-4 mobile:flex-col mobile:p-6">
                            <h3 class="font-bold mobile:mb-6">{{ 'archive.files' | transloco }}</h3>
                            <div class="flex flex-wrap gap-2 min-h-[70px] items-center mobile:flex-col mobile:h-auto">
                                <div class="w-[300px]">
                                    <app-custom-dropdown [options]="filterDropdownOptions"
                                        [(selectedOption)]="selectedFilterDropdown"
                                        (selectedOptionChange)="applySelectedFilter()"></app-custom-dropdown>
                                </div>

                                <label class="input input-bordered flex items-center gap-2 w-auto max-w-[300px]">
                                    <img src="assets/icons/search-normal.svg" alt="{{ 'shared.icon' | transloco }}">
                                    <input type="text" class="grow" placeholder="{{ 'shared.search' | transloco }}"
                                        [(ngModel)]="searchTerm" (keyup)="applySearchFilter()" />
                                </label>

                            </div>
                        </div>

                        <!--Separator-->
                        <div class="w-full h-[1px] bg-border"></div>

                        <!-- Table -->
                        <div class="overflow-x-auto w-full min-h-[40vh] h-full mb-4 block">
                            <table class="table w-full">
                                <!-- Header -->
                                <thead class="bg-primary-100 text-neutral-700 uppercase">
                                    <tr *ngIf="isContract" class="max-h-[50px]">
                                        <th class="border-b border-border px-4 py-4 font-normal">{{
                                            'archive.overview.file_name' | transloco }}</th>
                                        <th class="border-b border-border px-4 py-4 font-normal">{{
                                            'archive.overview.supplier' | transloco }}</th>
                                        <th class="border-b border-border px-4 py-4 font-normal">{{
                                            'archive.overview.commodity' | transloco }}</th>
                                        <th class="border-b border-border px-4 py-4 font-normal">{{ 'shared.location' |
                                            transloco }}</th>
                                        <th class="border-b border-border px-4 py-4 font-normal">{{
                                            'archive.overview.contract_start' | transloco }}</th>
                                        <th class="border-b border-border px-4 py-4 font-normal">{{
                                            'archive.overview.contract_end' | transloco }}</th>
                                        <th class="border-b border-border px-4 py-4 font-normal">{{
                                            'archive.overview.termination' | transloco }}</th>
                                        <th class="border-b border-border px-4 py-4 font-normal">{{
                                            'shared.status' | transloco }}</th>
                                        <th class="border-b border-border px-4 py-4 font-normal">{{
                                            'archive.overview.action' | transloco }}</th>
                                    </tr>

                                    <tr *ngIf="isInvoice" class="max-h-[50px]">
                                        <th class="border-b border-border px-4 py-4 font-normal">{{
                                            'archive.overview.file_name' | transloco }}</th>
                                        <th class="border-b border-border px-4 py-4 font-normal">{{
                                            'archive.overview.supplier' | transloco }}</th>
                                        <th class="border-b border-border px-4 py-4 font-normal">{{
                                            'archive.overview.commodity' | transloco }}</th>
                                        <th class="border-b border-border px-4 py-4 font-normal">{{ 'shared.location' |
                                            transloco }}</th>
                                        <th class="border-b border-border px-4 py-4 font-normal">{{
                                            'archive.overview.month' | transloco }}</th>
                                        <th class="border-b border-border px-4 py-4 font-normal">{{
                                            'shared.invoice_number' | transloco }}</th>
                                        <th class="border-b border-border px-4 py-4 font-normal">{{
                                            'shared.costs' | transloco }}</th>
                                        <th class="border-b border-border px-4 py-4 font-normal">{{
                                            'shared.consumption' | transloco }}</th>
                                        <th class="border-b border-border px-4 py-4 font-normal">{{
                                            'shared.status' | transloco }}</th>
                                        <th class="border-b border-border px-4 py-4 font-normal">{{
                                            'archive.overview.action' | transloco }}</th>
                                    </tr>

                                    <tr *ngIf="isUncategorized" class="max-h-[50px]">
                                        <th class="border-b border-border px-4 py-4 font-normal">{{
                                            'archive.overview.file_name' | transloco }}</th>
                                        <th class="border-b border-border px-4 py-4 font-normal">{{
                                            'shared.type' | transloco }}</th>
                                        <th class="border-b border-border px-4 py-4 font-normal">{{
                                            'shared.energy' | transloco }}</th>
                                        <th class="border-b border-border px-4 py-4 font-normal">{{
                                            'shared.status' | transloco }}</th>
                                        <th class="border-b border-border px-4 py-4 font-normal text-end">{{
                                            'archive.overview.action' | transloco }}</th>
                                    </tr>
                                </thead>
                                <!-- Content -->
                                <tbody *ngIf="isContract">
                                    <ng-container *ngFor="let fileInfo of showContracts; let i = index">
                                        <tr class="max-h-[50px]">
                                            <td class="border-b border-border px-4 py-4">{{ fileInfo.file?.filename
                                                ?? '' }}</td>
                                            <td class="border-b border-border px-4 py-4">{{ fileInfo.supplier }}</td>
                                            <td class="border-b border-border px-4 py-4">{{ getCommodity() | transloco
                                                }}
                                            </td>
                                            <td class="border-b border-border px-4 py-4">{{
                                                getLocationText(fileInfo.location_id ?? '') }}</td>
                                            <td class="border-b border-border px-4 py-4">{{ fileInfo.contract_start ??
                                                '' |
                                                isoDate }}</td>
                                            <td class="border-b border-border px-4 py-4">{{ fileInfo.contract_end ?? ''
                                                |
                                                isoDate
                                                }}</td>
                                            <td class="border-b border-border px-4 py-4">{{ fileInfo.termination_type }}
                                            </td>
                                            <td class="border-b border-border px-4 py-4">
                                                <app-contract-status
                                                    [statusEnum]="fileInfo.status"></app-contract-status>
                                            </td>
                                            <td class="border-b border-border px-4 py-4">
                                                <div class="flex gap-2 items-center">
                                                    <button (click)="downloadFile(fileInfo.file?.id ?? '')"
                                                        class="w-[24px] h-[24px]"><img
                                                            src="assets/icons/archive/download-circle.svg"
                                                            alt="{{ 'shared.download' | transloco }}"
                                                            title="{{ 'shared.download' | transloco }}"></button>
                                                    <button (click)="deleteFile(fileInfo.file?.id ?? '')"
                                                        class="w-[24px] h-[24px]"
                                                        title="{{ 'shared.delete' | transloco }}">
                                                        <svg width="24" height="24" viewBox="0 0 50 50"
                                                            xmlns="http://www.w3.org/2000/svg">
                                                            <circle cx="25" cy="25" r="24" fill="#FF0000" />

                                                            <image href="assets/icons/delete.svg" x="12" y="12"
                                                                height="25px" width="25px" />
                                                        </svg>
                                                    </button>
                                                </div>
                                            </td>
                                        </tr>
                                    </ng-container>
                                </tbody>

                                <tbody *ngIf="isInvoice">
                                    <ng-container *ngFor="let fileInfo of showInvoices; let i = index">
                                        <tr class="max-h-[50px]">
                                            <td class="border-b border-border px-4 py-4">{{ fileInfo.file.filename }}
                                            </td>
                                            <td class="border-b border-border px-4 py-4">{{
                                                invoiceHelper.getInvoiceSupplierName(fileInfo) }}</td>
                                            <td class="border-b border-border px-4 py-4">{{ getCommodity() | transloco
                                                }}
                                            </td>
                                            <td class="border-b border-border px-4 py-4">{{
                                                getLocationText(fileInfo.location_id ?? '') }}</td>
                                            <td class="border-b border-border px-4 py-4">{{ fileInfo.for_period ?? '' |
                                                isoPeriod }}</td>
                                            <td class="border-b border-border px-4 py-4">{{ fileInfo.invoice_number ??
                                                '' }}
                                            </td>
                                            <td class="border-b border-border px-4 py-4">{{
                                                fileInfo.invoice_amount_net_actual |
                                                number:'1.2-2' }} €
                                            </td>
                                            <td class="border-b border-border px-4 py-4">{{ fileInfo.total_consumption |
                                                number:'1.2-2'
                                                }} {{
                                                getCommodityUnit() }}
                                            </td>
                                            <td class="border-b border-border px-4 py-4">
                                                <app-invoice-status [statusEnum]="fileInfo.status"
                                                    [visibilityStatus]="fileInfo.visibility_status"></app-invoice-status>
                                            </td>
                                            <td class="border-b border-border px-4 py-4">
                                                <div class="flex gap-2 items-center">
                                                    <button *ngIf="isUserAdmin && !isUploadingFileReplacement"
                                                        class="w-[24px] h-[24px]"
                                                        (click)="triggerFileInput(fileInfo.file.id || '')"><img
                                                            src="assets/icons/archive/replace-red.svg"
                                                            alt="{{ 'archive.replace_file_extraction_data' | transloco }}"
                                                            title="{{ 'archive.replace_file_extraction_data' | transloco }}">
                                                    </button>
                                                    <span class="loading loading-spinner text-error-300"
                                                        *ngIf="isUploadingFileReplacement"></span>
                                                    <button (click)="downloadFile(fileInfo.file.id)"
                                                        class="w-[24px] h-[24px]"><img
                                                            src="assets/icons/archive/download-circle.svg"
                                                            alt="{{ 'shared.download' | transloco }}"
                                                            title="{{ 'shared.download' | transloco }}"></button>
                                                    <button (click)="deleteFile(fileInfo.file.id)"
                                                        class="w-[24px] h-[24px]"
                                                        title="{{ 'shared.delete' | transloco }}">
                                                        <svg width="24" height="24" viewBox="0 0 50 50"
                                                            xmlns="http://www.w3.org/2000/svg">
                                                            <circle cx="25" cy="25" r="24" fill="#FF0000" />

                                                            <image href="assets/icons/delete.svg" x="12" y="12"
                                                                height="25px" width="25px" />
                                                        </svg>
                                                    </button>
                                                </div>
                                            </td>
                                        </tr>
                                    </ng-container>
                                </tbody>

                                <tbody *ngIf="isUncategorized">
                                    <ng-container *ngFor="let fileInfo of showFiles; let i = index">
                                        <tr class="max-h-[50px]">
                                            <td class="border-b border-border px-4 py-4">{{ fileInfo.filename
                                                ?? '' }}</td>
                                            <td class="border-b border-border px-4 py-4">
                                                <app-file-type-text
                                                    [fileType]="fileInfo.file_type"></app-file-type-text>
                                            </td>
                                            <td class="border-b border-border px-4 py-4">
                                                <app-energy-type-text
                                                    [energyType]="fileInfo.energy_type"></app-energy-type-text>
                                            </td>
                                            <td class="border-b border-border px-4 py-4">
                                                <span [title]="getStatusTooltip(fileInfo.status) | transloco">
                                                    {{
                                                    (getExternalStatusTranslocoKey(fileInfo.external_status, fileInfo.status)) |
                                                    transloco }}
                                                </span>
                                            </td>
                                            <td class="border-b border-border px-4 py-4">
                                                <div class="flex gap-2 items-center justify-end">
                                                    @if(canUserTriggerReupload(fileInfo)){
                                                    <!-- Reupload button -->
                                                    <button (click)="triggerReupload(fileInfo)"
                                                        class="hover:bg-error-100 text-sm text-error-500 border border-error-400 rounded-[16px] px-2 py-1"
                                                        [ngClass]="[sendingReupload ? 'bg-error-400 cursor-not-allowed' : '']"
                                                        [disabled]="sendingReupload">
                                                        {{'archive.reupload' | transloco}}
                                                    </button>
                                                    }@else if(canUserTriggerRetry(fileInfo)){
                                                    <!-- Retry button-->
                                                    <button (click)="triggerRetry(fileInfo)"
                                                        class="hover:bg-primary-200 text-sm text-primary border border-primary rounded-[16px] px-2 py-1"
                                                        [ngClass]="[sendingRetry ? 'bg-neutral-500 cursor-not-allowed' : '']"
                                                        [disabled]="sendingRetry">
                                                        {{'archive.retry' | transloco}}
                                                    </button>}
                                                    <button (click)="downloadFile(fileInfo.id)"
                                                        class="w-[24px] h-[24px]"><img
                                                            src="assets/icons/archive/download-circle.svg"
                                                            alt="{{ 'shared.download' | transloco }}"
                                                            title="{{ 'shared.download' | transloco }}"></button>
                                                    <button (click)="deleteFile(fileInfo.id)" class="w-[24px] h-[24px]"
                                                        title="{{ 'shared.delete' | transloco }}">
                                                        <svg width="24" height="24" viewBox="0 0 50 50"
                                                            xmlns="http://www.w3.org/2000/svg">
                                                            <circle cx="25" cy="25" r="24" fill="#FF0000" />

                                                            <image href="assets/icons/delete.svg" x="12" y="12"
                                                                height="25px" width="25px" />
                                                        </svg>
                                                    </button>
                                                </div>
                                            </td>
                                        </tr>
                                    </ng-container>
                                </tbody>

                                <tr
                                    *ngIf="((isContract && showContracts.length > 0) || (isInvoice && showInvoices.length > 0) || (isUncategorized && showFiles.length > 0)) && !loadMoreHidden">
                                    <td colspan="10">
                                        <div class="w-full h-full flex justify-center items-start">
                                            <div class="w-[150px] h-[50px]">
                                                <app-custom-button buttonText="{{ 'shared.load_more' | transloco }}"
                                                    [isDisabled]="dataIsLoading" backgroundColor="bg-neutral-500"
                                                    textColor="text-white" borderColor="border:bg-neutral-500"
                                                    hoverBackgroundColor="hover:bg-neutral-1200"
                                                    (buttonClick)="loadNewData()">
                                                </app-custom-button>
                                            </div>
                                        </div>
                                    </td>
                                </tr>
                            </table>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <app-custom-footer></app-custom-footer>
    </div>
</div>